export enum Tasks {
    OBJECT_DETECTION = "find-objects",
    DEFECT_DETECTION = "detect-defects",
    ACTION_DETECTION = "detect-actions"
}

export const TaskLabels = {
    [Tasks.OBJECT_DETECTION]: "Find Objects",
    [Tasks.DEFECT_DETECTION]: "Detect Defects",
    [Tasks.ACTION_DETECTION]: "Detect Actions"
};

export type Task = (typeof Tasks)[keyof typeof Tasks];

export enum Flows {
    SETUP = "setup",
    BUILD = "build",
    DEPLOY = "deploy",
    SHARE = "share"
}

export type Flow = (typeof Flows)[keyof typeof Flows] | null;

export const FlowToRoutes = { [Flows.SETUP]: "", [Flows.BUILD]: "build", [Flows.DEPLOY]: "" };
export enum BuildSteps {
    UPLOAD = "upload",
    PROMPT = "prompt",
    REVIEW = "review",
    PREVIEW = "preview"
}

export type BuildStep = (typeof BuildSteps)[keyof typeof BuildSteps];

export enum BuildStepRoutes {
    UPLOAD = "",
    PROMPT = "prompt",
    REVIEW = "review",
    PREVIEW = "preview"
}

export type BuildStepRoute = (typeof BuildStepRoutes)[keyof typeof BuildStepRoutes];

// Map build steps to relative paths within build routes
export const BuildStepToRouteMap: Record<BuildStep, BuildStepRoutes> = {
    [BuildSteps.UPLOAD]: BuildStepRoutes.UPLOAD,
    [BuildSteps.PROMPT]: BuildStepRoutes.PROMPT,
    [BuildSteps.REVIEW]: BuildStepRoutes.REVIEW,
    [BuildSteps.PREVIEW]: BuildStepRoutes.PREVIEW
};

export const BuildRouteToStepMap: Record<BuildStepRoute, BuildStep> = {
    [BuildStepRoutes.UPLOAD]: BuildSteps.UPLOAD,
    [BuildStepRoutes.PROMPT]: BuildSteps.PROMPT,
    [BuildStepRoutes.REVIEW]: BuildSteps.REVIEW,
    [BuildStepRoutes.PREVIEW]: BuildSteps.PREVIEW
};

export enum DeploySteps {
    DEPLOY = "deploy"
    // REVIEW = "review",
    // PROMPT = "prompt"
}

export type DeployStep = (typeof DeploySteps)[keyof typeof DeploySteps];

export enum DeployStepRoutes {
    DEPLOY = "deploy"
    // REVIEW = "review",
    // PROMPT = "prompt"
}

export type DeployStepRoute = (typeof DeployStepRoutes)[keyof typeof DeployStepRoutes];

// Map deploy steps to relative paths within deploy routes
export const DeployStepToRouteMap: Record<DeployStep, DeployStepRoutes> = {
    [DeploySteps.DEPLOY]: DeployStepRoutes.DEPLOY // index route
    // [DeploySteps.REVIEW]: DeployStepRoutes.REVIEW,
    // [DeploySteps.PROMPT]: DeployStepRoutes.PROMPT
};

export const DeployRouteToStepMap: Record<DeployStepRoutes, DeployStep> = {
    [DeployStepRoutes.DEPLOY]: DeploySteps.DEPLOY
    // [DeployStepRoutes.REVIEW]: DeploySteps.REVIEW,
    // [DeployStepRoutes.PROMPT]: DeploySteps.PROMPT
};

export type Step = BuildStep | DeployStep | undefined;

export enum BuildPromptSteps {
    ANNOTATE_DATA = "annotate_data",
    REVIEW_PREDICTIONS = "review_predictions"
}

export type BuildPromptStep = (typeof BuildPromptSteps)[keyof typeof BuildPromptSteps];
